import { initializeApp } from 'firebase/app';
import { getFunctions } from 'firebase/functions';
import { getFirestore } from 'firebase/firestore';
import { getAuth } from 'firebase/auth';
import { getDatabase } from 'firebase/database';
import { getStorage } from 'firebase/storage';
import { getRemoteConfig } from 'firebase/remote-config';
import { CONFIGS } from './DB_CONFIG';
import { getEnvName } from '../utils/environmentUtil';

const env = getEnvName();

const getConfig = (envName: string) => {
    return CONFIGS[envName];
};
// using local storage here to get the region for now
const databaseId = window.localStorage.getItem('region') ?? '(default)';

export const APP = initializeApp(getConfig(env));
export const FUNCTIONS = getFunctions(APP);
export const FIRESTORE = getFirestore(APP, databaseId);
export const UKFUNCTIONS = getFunctions(APP, 'europe-west2');
export const AUTH = getAuth(APP);
export const DATABASE = getDatabase(APP);
export const STORAGE = getStorage(APP);
export const remoteConfig = getRemoteConfig(APP);
remoteConfig.settings.minimumFetchIntervalMillis = 3600000;

export const clearRegionConfig = () => {
    if (!window.localStorage) {
        return;
    }
    window.localStorage.removeItem('region');
};

export const CURRENT_USER = AUTH.currentUser;
